/* Common imports */

import React from "react";
import { makeStyles } from "@material-ui/core";

/* Component imports */

import Cookies from "./sub-components/Cookies";
import DryCake from "./sub-components/DryCake";
import Bread from "./sub-components/Bread";
import Dessert from "./sub-components/Dessert";
// import IceCream from "./sub-components/IceCream";

const useStyles = makeStyles((theme) => ({
  sectionContainer: {
    display: "flex",
    flexDirection: "row",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      justifyContent: "center",
    },
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    margin: "0rem 0rem 1rem 0rem",
  },
}));

const ProductMenu = () => {
  const classes = useStyles();
  return (
    <React.Fragment>
      <div className={classes.sectionContainer}>
        <Cookies />
      </div>
      <div className={classes.sectionContainer}>
        <DryCake />
      </div>
      <div className={classes.sectionContainer}>
        <Bread />
      </div>
      <div className={classes.sectionContainer}>
        <Dessert />
      </div>
      {/* <div className={classes.sectionContainer}>
        <IceCream />
      </div> */}
    </React.Fragment>
  );
};

export default ProductMenu;
